module.exports = __webpack_public_path__ + "img/Drivers_Regulatory_Constraints.e98e9f17.jpg";